<template>
    <div class="register-screen">
        <b-row>
            <h5 class="register-title">{{ $t('message.register') }}</h5>
            <b-icon class="routes-back-arrow" icon="x" variant="black" font-scale="0.5" @click="handleClose"></b-icon>
        </b-row>
        <div class="register-desc-text">
            <h6 >{{ $t('message.registerText') }}</h6>
        </div>
        <div class="phone-number-input">
            <Input v-model="mobileNumber" input_type="number" :label_form="$t('message.phoneNumber')"/>
        </div>
        <div class="companyName">
            <Input v-model="companyName" :label_form="$t('message.comapnyName')"/>
        </div>
        <div class="type-of-service">
            <b-row class="row-margin">
                <b-col cols="12">
                    <b-form-group :label="$t('message.typeOfService')">
                    <b-form-radio-group v-model="selected">
                        <b-form-radio value="Fleet Owner">{{ $t('message.fo') }}</b-form-radio>
                        <b-form-radio value="Broker">{{ $t('message.broker') }}</b-form-radio>
                        <b-form-radio value="Both">{{ $t('message.both') }}</b-form-radio>
                    </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
        </div>
        <div class="place-bid-btn place-bid-btn-align">
            <b-button :disabled="isdisabled" class="ft-btn" block variant="dark"
                    @click="handleRegister">
            {{ $t('message.loginAndPlaceBid') }}
            </b-button>
        </div>
    </div>
</template>
<script>
import Input from '../components/Input.vue'
import axios from "axios";
export default {
    props: {
        item: Object,
        hash_id: String,
        contact:String
    },
    components: {
        Input,
    },
    data() {
        return {
            mobileNumber:this.contact,
            companyName:'',
            selected:'Fleet Owner'
        }
    },
    updated() {
        this.mobileNumber = this.mobileNumber.slice(0, 10);
    },
    methods:{
        async handleRegister(){

           const request = {
                "name": this.companyName,
                "phone":this.mobileNumber,
                "type" :[this.selected]
            }
            const body = request
            const headers = {
                    'Content-Type': 'application/json'
                }
            const {data}=await axios.post(`/supplier/${this.hash_id}`, body, {headers})
            if(data.success){
                this.$emit('submit-register', data)
            }
            //alert("status"+status)
           // this.$emit('submit-register', data)
        },
        handleClose(){
            this.$emit('handle-close');
        }
    },
    computed: {
        isdisabled: function(){
            return this.mobileNumber=='' ||this.companyName==''||this.selected==''
        }
    }
}
</script>
<style >
.register-screen{
    width:100%;
}
.register-title{
    margin-left:10%;
    margin-top:10px
}
.register-desc-text{
    padding-left:8%;
    padding-right:8%;
    padding-top:5%;
}
.phone-number-input{
    margin-left:10%;
    margin-right: 10%;
    margin-top: 10%;
}
.companyName{
    margin-left:10%;
    margin-top:5%;
    margin-right: 10%;
}
.type-of-service{
    margin-left:7%;
    margin-top:8%
}
.place-bid-btn-align{
    margin-left:10%;
    margin-right:10%;
    margin-top:10%;
}
.routes-back-arrow{
    width:20px;
    height:20px;
    margin-top:11px;
    margin-left:60%;
    stroke:#707070;
    stroke-width:1px;
}
</style>